define(function(require) {
	// general
	const Radio = require('backbone.radio');
	const MyAttachmentChannel = Radio.channel('addAttachmentChannel');
	const modal_region = require('civicsUtils/modal_region.js');
	const attachmentConverter = require('civicsUtils/attachment_converter')
	const ViewManager = require('civicsUtils/view_manager');

	// models
	const AttachmentModel = require('civicsModels/attachment_model');
	// collections
	const IpsModelCollection = require('civicsBase/ipsModelCollection');
	const DocumentTypeCollection = require('civicsCollections/document_type_collection');
	// templates
	const tpl = require('civicsViews/attachments/templates/t_lov_attachments_list.hbs');
	// views
	const AddAttachmentView = require('./v_cpv_add_attachments');

	const TableView = require('./v_cpv_attachments_list');

	const attachment_utility = require('civicsUtils/attachment_utility');

	return Marionette.LayoutView.extend({
		initialize: function(options) {
			this.config = this.config = options.config ? options.config : {};
			this.config.globalConfig = ViewManager.globalConfig();
          	this.config.IsForBilling = options.isForBilling;
			this.config.BillingAccountKey = options.billingAccountKey;
		  
			this.isAddProcess = options.isAddProcess === true; //if we are in the add process for 860+, don't save attachments to server yet
			this.isReviewProcess = options.isReviewProcess === true; //if we are in the add instrument - summary view tab.
			this.allowDelete = options.allowDelete === true;
			this.collection = options.collection ? new IpsModelCollection(attachmentConverter.convertAttachments(options.collection.toJSON())) : new IpsModelCollection();

			this.isProvider = options.isProvider;
			this.isCustomer = options.isCustomer && !options.isProvider;
			this.isPublic = !options.isCustomer && !options.isProvider;
			this.documentTypeCollection = options.documentTypeCollection;
			this.promisesArr = [];
			this.viewName = options.viewName;
			var self = this;

			if (ViewManager.versionRange('8.8.0.0')) {
				self.getAdditionalDocumentType();
			} else {
				var promise = $.Deferred();
				self.promisesArr.push(promise);
				promise.resolve();
			}

			this.newAttachmentsCollection = new IpsModelCollection();
			if (this.isAddProcess && options.collection) {
				if (options.newAttachmentsCollection) {
					this.newAttachmentsCollection = options.newAttachmentsCollection;
				} else {
					this.newAttachmentsCollection = options.collection;
				}
			}
			this.productFamily = options.productFamily;
			this.catalog = this.getCatalog();

			this.enabledProviders = this.config.globalConfig.get('attachments').get('enabledProviders');
			this.isProviderEnabled = false;
			if(!ViewManager.versionRange('8.8.0.2005')) {
				this.isProviderEnabled = true;
			} else {
				this.isProviderEnabled = this.enabledProviders.includes(this.catalog);
			}

			this.showAllItems = false;

			this.ShowAddButton = options.showAddButton;
			this.displayAttachments = options.displayAttachments;

			this.parentMoniker = options.parentMoniker;
			this.parentPrimaryKey = options.parentPrimaryKey;

			var self = this;

			this.radioChannel = MyAttachmentChannel;
			this.radioChannel.on('attachments:added', function(myList) {
				// Pass the list back up to the parent (ie: HearingDetails)
				this.triggerMethod('attachments:added', myList);
				// refresh the list with the new attachments
			}.bind(this));

			this.radioChannel.on('attachments:done', function(myList) {
				// Pass the list back up to the parent (ie: HearingDetails)
				// if(__DEV__) console.log('lov_attachments -- radio channel attachments:done');
				this.triggerMethod('attachments:done', myList);
				// refresh the list with the new attachments
			}.bind(this));

			this.radioChannel.on('attachments:validate', function(view) {
				this.triggerMethod('attachments:validate', view);
			}.bind(this));

			this.radioChannel.on('attachments:delete', function(view) {
				this.triggerMethod('attachments:delete', view);
				this.render();
			}.bind(this));

			this.radioChannel.on('attachments:edit', function(v) {
				var modelToUpdate = null;
				this.triggerMethod('attachments:edit', v);
				if (self.isAddProcess)
					modelToUpdate = this.collection.find(function(m) {
						return m.get('cid') == v.cid
					});
				else
					modelToUpdate = this.collection.find(function(m) {
						return m.get('id') == v.id
					});

				if (modelToUpdate != null) {
					modelToUpdate.set(v.toJSON());
				}
				this.render();
			}.bind(this));

			//https://stackoverflow.com/questions/11381673/detecting-a-mobile-browser
			this.isMobile = function() {
				var check = false;
				(function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
				return check;
			}();

			this.setupMonitoringOfAttachments();
			//only show page level alert on page load.
			this.showVirusAlert();
		},
		onBeforeDestroy: function() {
			this.radioChannel.reset();
		},
		template: tpl,
		regions: {
			table: '.attachment-list-div',
			modalRegion: {
				selector: 'body .rhythm-modals',
				regionClass: modal_region,
			},
		},
		ui: {
			attachmentFiles: '.attachmentFiles',
			uploadModalLink: '.upload-modal-link',
			downloadModalLink: '.download-modal-link',
			attachmentList: '.attachment-list-div',
			content: '.content',
			badge: '.count-attachments'
		},
		events: {
			'click @ui.uploadModalLink': 'openUploadModal',
			'click @ui.downloadModalLink': 'downloadAllAttachments',
		},
		childEvents: {
			'singleDownload:clicked': function(childView, filePath) {
				this.downloadAttachment(filePath);
			},
		},
		onRender: function() {
			this.collection.sort('filename', 'asc');
			$.when.apply($, this.promisesArr).then(() => {
				this.documentTypesLoaded = true;
				this.count = this.determineCount();
				this.ui.badge.html(this.count);

				this.showDownloadAllButton();
				this.attachmentListView = new TableView({
					model: this.collection,
					documentTypeCollection: this.documentTypeCollection,
					config: this.config,
					showAllItems: this.showAllItems,
					radioChannel: this.radioChannel,
					isAddProcess: this.isAddProcess,
					isReviewProcess: this.isReviewProcess,
					allowDelete: this.allowDelete,
					modalRegion: this.modalRegion,
					parentMoniker: this.parentMoniker,
					parentPrimaryKey: this.parentPrimaryKey,
					isCustomer: this.isCustomer,
					isServiceProvider: this.isProvider,
					newAttachmentsCollection: this.newAttachmentsCollection,
					isProviderEnabled: this.isProviderEnabled,
					enabledProviders: this.enabledProviders,
					viewName: this.viewName
				});

				this.table.show(this.attachmentListView);

				this.$el.rhythmCivicsTooltipInit();
				this.$el.rhythmThemeInit();
			})
		},
		showVirusAlert:function(){
			if(this.hasInfectedFile()){
				ViewManager.openAlert(i18n.t('CIVICS.ATTACHMENTS.VIRUS_SCAN_STATUS.VIRUS_DETECTED_ALERT'));
			}
		},
		hasInfectedFile: function(){
			return  this.collection.models.some(model => {
				let virusScanResults = model.get('virusScanResults')?.toJSON() || {infected:false};
				return virusScanResults.infected === true;
			});
		},
		onShow: function() {
		},
		setupMonitoringOfAttachments: function () {
			// Pass productFamily directly - utility will convert to moniker
			attachment_utility.monitorScanStatus(
				this.collection,
				this.parentMoniker,
				this.options.parentPrimaryKey
			).then((result) => {
				if (result.noPendingFiles) return;

				this.collection.reset(attachmentConverter.convertAttachments(result.attachments));
				this.render();
				this.showVirusAlert();
			}).catch((error) => {
				//leave this console log in - this will only happen when we have a real error that we need to be able to track.
				console.log('Error monitoring attachment scans: ' + error.message);
			});
		},
		getCatalog: function() {
			var catalog;

			switch (this.productFamily.toUpperCase()) {
				case "SERVICEREQUEST":
					catalog = this.config.globalConfig.get("attachments").get("crmCatalog");
					break;
				case "BUILDING":
					catalog = this.config.globalConfig.get("attachments").get("buildingCatalog");
					break;
				case "BUSINESSLICENSE":
					catalog = this.config.globalConfig.get("attachments").get("licenseCatalog");
					break;
				case "CODEENFORCEMENT":
					catalog = this.config.globalConfig.get("attachments").get("caseCatalog");
					break;
				case "PLANNING":
					catalog = this.config.globalConfig.get("attachments").get("planningCatalog");
					break;
				case "PROJECT":
					catalog = this.config.globalConfig.get("attachments").get("projectCatalog");
					break;
				case "TRADELICENSE":
					catalog = this.config.globalConfig.get("attachments").get("tradeCatalog");
					break;
				case "USE":
					catalog = this.config.globalConfig.get("attachments").get("useCatalog");
					break;
				default:
					catalog = this.config.globalConfig.get("attachments").get("defaultCatalog");
			}

			// If the product specific catalog is not set, use the default
			if (!catalog || catalog.length == 0) {
				catalog = this.config.globalConfig.get("attachments").get("defaultCatalog");
			}
			return catalog;
		},
		openUploadModal: function(e) {
			e.preventDefault();
			e.stopImmediatePropagation();
			e.stopPropagation();

			if(!this.isProviderEnabled) {
				return;
			}

			if (this.addAttachmentView) {
				this.addAttachmentView.destroy();
			}
			this.addAttachmentView = new AddAttachmentView({
				config: this.config,
				isAddProcess: this.isAddProcess,
				modalRegion: this.modalRegion,
				itemOptions: {
					productFamily: this.productFamily,
					parentMoniker: this.parentMoniker,
					parentPrimaryKey: this.parentPrimaryKey,
					isAddProcess: this.isAddProcess,
					isCustomer: this.isCustomer,
					isProvider: this.isProvider,
				},
			});
			this.modalRegion.show(this.addAttachmentView);
			this.modalRegion.showModal();
			// return false to stop event propagation
			return false;
		},
		downloadAllAttachments: function(e) {
			e.preventDefault();
			e.stopImmediatePropagation();
			e.stopPropagation();
			// if (__DEV__) console.log('lov_attachments_list -- downloadAllAttachments');
			var attachment = new AttachmentModel();
			var self = this;
			_.each(this.collection.models, function(model, index) {
				// var attachId = model.get('attachmentId') ? model.get('attachmentId') : model.get('attachment');
				// var filename = model.get('name') ? model.get('name') : model.get('attachmentName');
				// var downloadPath = attachment.urlRoot + '/' + +attachId + "?GetIcon=false&fname=" + filename;
				var virusScanResults = model.get('virusScanResults')?.toJSON() || {safe: true};
				if (virusScanResults.safe !== true) {
					return;
				}

				if (model.get('documentType')) {
					var doctype = (typeof model.get('documentType').get('portalConfigurations') !== 'undefined') ? model.get('documentType') : self.determineDocumentType(model.get('documentType'));
					var actions = self.getActionPermissions(doctype);
					if ((actions.open.customer && self.isCustomer) || (actions.open.serviceProvider && self.isProvider) || (actions.open.public && self.isPublic)) {
						window.setTimeout(function() {
							self.downloadAttachment(model.get('documentUri'));
						}, index * 1000);
					}
				}
				
			}, this);
			// return false to stop event propagation
			return false;
		},
		downloadAttachment: function(filepath) {
			var src = filepath.replace(/ /g, '_');
			if(this.isMobile){
				window.open(src, "_blank");
			} else {
				var iframe = window.document.createElement('iframe');
				var $iframe = $(iframe).attr({
					style: 'display:none',
					src: src,
				});
				this.ui.attachmentFiles.append($iframe);
			}
		},
		determineDocumentType: function(model) {
			return this.documentTypeCollection.find(function(doctype) {
				return doctype.get('name') == model.get('name');
			});
		},
		getActionPermissions: function(doctype) {
			var actions = {};
			if (doctype != null) {
				doctype.get('portalConfigurations').each(function(actionConfig) {
					actions[actionConfig.get('Action').toLowerCase()] = {
						"customer": actionConfig.get('customer'),
						"serviceProvider": actionConfig.get('serviceProvider'),
						"public": actionConfig.get('public')
					};
				});
			}

			return actions;
		},
		getAdditionalDocumentType: function() {
			var self = this;
			var uniqueEDMProvider = [];

			if (self.collection && self.collection.length > 0) {
				uniqueEDMProvider = _.uniq(self.collection.toJSON(), function(e) {
					return e.provider;
				});

				uniqueEDMProvider.forEach(function(model) {
					if (model.provider != self.documentTypeCollection.provider) {
						var additionalDoctypeCollection = new DocumentTypeCollection();
						additionalDoctypeCollection.provider = model.provider;
						var promise = $.Deferred();
					self.promisesArr.push(promise);
						additionalDoctypeCollection.fetch().done(function() {
							additionalDoctypeCollection.forEach(function(additionalDocType) {
								var docTypeExist = self.documentTypeCollection.find(function(d) {
									return d.get('name') == additionalDocType.get('name');
								});

								if (typeof docTypeExist == 'undefined') {
									self.documentTypeCollection.add(additionalDocType);
								}
							});
							promise.resolve();
						}).fail(function(response, status, xhrResponse) {
							promise.reject();
						});
					}
				});
			} else {
				var promise = $.Deferred();
				self.promisesArr.push(promise);
				promise.resolve();
			}
		},
		determineCount: function(checkOpenCount) {
			var self = this;

			if (ViewManager.versionRange('8.8.0.0') && (self.documentTypesLoaded || typeof checkOpenCount !== 'undefined')) {
				var listedModelCount = 0;
				_.each(self.collection.models, function(model, index) {
					if (model.get('documentType')) {
						var doctype = (typeof model.get('documentType').get('portalConfigurations') !== 'undefined') ? model.get('documentType') : self.determineDocumentType(model.get('documentType'));
						var actions = self.getActionPermissions(doctype);
						if (self.isAddProcess || (actions.list.customer && self.isCustomer) || (actions.list.serviceProvider && self.isProvider) || (actions.list.public && self.isPublic)) {
							if(typeof checkOpenCount !== 'undefined'){
								if ((actions.open.customer && self.isCustomer) || (actions.open.serviceProvider && self.isProvider) || (actions.open.public && self.isPublic))
									listedModelCount++;
							}
							else
								listedModelCount++;
						}
					}
				});
				return listedModelCount;
			} else {
				return self.collection.length;
			}
		},
		showDownloadAllButton: function() {
			if(!ViewManager.versionRange('8.8.0.0') && this.isPublic) {
				return false;
			}

			// Only show download all button if there are 2+ files that can actually be downloaded
			var downloadableCount = this.countDownloadableFiles();
			if (downloadableCount >= 2 && !this.isAddProcess && !this.isMobile) {
				this.ui.downloadModalLink.removeClass('hide');
			}
		},
		// Counts how many files are safe to download (not infected, not pending scan, and user has permission)
		countDownloadableFiles: function() {
			var self = this;
			var count = 0;
			
			_.each(this.collection.models, function(model) {
				// Check if file is safe (not infected and not pending scan)
				let virusScanResults = model.get('virusScanResults')?.toJSON() || {safe: true};
				if (virusScanResults.safe !== true) {
					return; // Skip infected or pending files
				}
				
				// Check if user has permission to download this file
				if (model.get('documentType')) {
					var doctype = (typeof model.get('documentType').get('portalConfigurations') !== 'undefined') ? model.get('documentType') : self.determineDocumentType(model.get('documentType'));
					var actions = self.getActionPermissions(doctype);
					if ((actions.open.customer && self.isCustomer) || (actions.open.serviceProvider && self.isProvider) || (actions.open.public && self.isPublic)) {
						count++;
					}
				}
			});
			
			return count;
		},
		templateHelpers: function() {
			this.count = this.determineCount();
			return {
				virusDetected:this.hasInfectedFile(),
				Count: ()=> { return this.count },
				//Allows Add Attachment button to be shown if there are at least 2 already there OR user is owner
				ShowButtons: ()=> { return this.count >= 2 || this.ShowAddButton },
				ShowAddButton: this.ShowAddButton,
				disableUpload: !this.isProviderEnabled,
				buttonType: (this.ShowAddButton) ? 'secondary' : 'primary',
				viewName: this.viewName !=null ? this.viewName : Math.floor(Math.random() * 100000), // if the view name is not defined use a random string as ID
			};
		},
	});
});
